export default "__VITE_ASSET__BjImLxOt__"